module.exports = __webpack_public_path__ + "img/alcohol.eacaa4b4.svg";